import { SVGProps } from 'react';

export default function SelectTrainerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect
        x="0.784393"
        y="1.47632"
        width="55"
        height="55"
        rx="7.5"
        fill="#3F454D"
        stroke="inherit"
      />
      <circle
        cx="12.6151"
        cy="36.4404"
        r="3.9386"
        transform="rotate(0.58728 12.6151 36.4404)"
        fill="inherit"
      />
      <circle
        cx="25.429"
        cy="47.5093"
        r="3.9386"
        transform="rotate(0.58728 25.429 47.5093)"
        fill="inherit"
      />
      <circle
        cx="12.6189"
        cy="17.0798"
        r="3.9386"
        transform="rotate(0.58728 12.6189 17.0798)"
        fill="inherit"
      />
      <circle
        cx="35.7632"
        cy="9.58326"
        r="3.9386"
        transform="rotate(0.58728 35.7632 9.58326)"
        fill="inherit"
      />
      <circle
        cx="44.271"
        cy="43.0627"
        r="3.9386"
        transform="rotate(0.58728 44.271 43.0627)"
        fill="inherit"
      />
      <circle
        cx="46.9241"
        cy="22.106"
        r="3.9386"
        transform="rotate(0.58728 46.9241 22.106)"
        fill="inherit"
      />
      <mask id="path-8-inside-1_7639_98" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.9029 27.5422C33.869 30.8558 31.1553 33.5144 27.8418 33.4804C24.5282 33.4464 21.8696 30.7328 21.9036 27.4192C21.9375 24.1057 24.6512 21.4471 27.9648 21.481C31.2783 21.515 33.9369 24.2287 33.9029 27.5422ZM35.9028 27.5627C35.8575 31.9808 32.2393 35.5256 27.8213 35.4803C23.4032 35.435 19.8584 31.8168 19.9037 27.3987C19.949 22.9807 23.5672 19.4359 27.9853 19.4811C32.4033 19.5264 35.9481 23.1447 35.9028 27.5627ZM27.8622 31.4805C30.0713 31.5032 31.8804 29.7308 31.903 27.5217C31.9257 25.3127 30.1533 23.5036 27.9442 23.4809C25.7352 23.4583 23.9261 25.2307 23.9035 27.4397C23.8808 29.6488 25.6532 31.4579 27.8622 31.4805Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9029 27.5422C33.869 30.8558 31.1553 33.5144 27.8418 33.4804C24.5282 33.4464 21.8696 30.7328 21.9036 27.4192C21.9375 24.1057 24.6512 21.4471 27.9648 21.481C31.2783 21.515 33.9369 24.2287 33.9029 27.5422ZM35.9028 27.5627C35.8575 31.9808 32.2393 35.5256 27.8213 35.4803C23.4032 35.435 19.8584 31.8168 19.9037 27.3987C19.949 22.9807 23.5672 19.4359 27.9853 19.4811C32.4033 19.5264 35.9481 23.1447 35.9028 27.5627ZM27.8622 31.4805C30.0713 31.5032 31.8804 29.7308 31.903 27.5217C31.9257 25.3127 30.1533 23.5036 27.9442 23.4809C25.7352 23.4583 23.9261 25.2307 23.9035 27.4397C23.8808 29.6488 25.6532 31.4579 27.8622 31.4805Z"
        fill="inherit"
      />
      <path
        d="M27.8418 33.4804L27.85 32.6804L27.85 32.6804L27.8418 33.4804ZM21.9036 27.4192L21.1036 27.411L21.1036 27.411L21.9036 27.4192ZM27.9648 21.481L27.973 20.6811L27.9648 21.481ZM19.9037 27.3987L20.7036 27.4069L19.9037 27.3987ZM27.9853 19.4811L27.9935 18.6812L27.9853 19.4811ZM31.903 27.5217L32.703 27.5299L31.903 27.5217ZM27.8622 31.4805L27.8704 30.6806L27.8622 31.4805ZM27.9442 23.4809L27.936 24.2809L27.936 24.2809L27.9442 23.4809ZM23.9035 27.4397L23.1035 27.4315L23.1035 27.4315L23.9035 27.4397ZM27.8336 34.2804C31.5889 34.3189 34.6644 31.3058 34.7029 27.5504L33.103 27.534C33.0735 30.4057 30.7217 32.7099 27.85 32.6804L27.8336 34.2804ZM21.1036 27.411C21.0651 31.1664 24.0782 34.2419 27.8336 34.2804L27.85 32.6804C24.9782 32.651 22.6741 30.2992 22.7035 27.4274L21.1036 27.411ZM27.973 20.6811C24.2176 20.6426 21.1421 23.6557 21.1036 27.411L22.7035 27.4274C22.733 24.5557 25.0848 22.2516 27.9566 22.281L27.973 20.6811ZM34.7029 27.5504C34.7414 23.7951 31.7283 20.7196 27.973 20.6811L27.9566 22.281C30.8283 22.3104 33.1324 24.6623 33.103 27.534L34.7029 27.5504ZM27.8131 36.2803C32.6729 36.3301 36.653 32.4308 36.7028 27.5709L35.1029 27.5545C35.0621 31.5308 31.8057 34.7211 27.8295 34.6803L27.8131 36.2803ZM19.1037 27.3905C19.0539 32.2504 22.9532 36.2304 27.8131 36.2803L27.8295 34.6803C23.8532 34.6396 20.6629 31.3832 20.7036 27.4069L19.1037 27.3905ZM27.9935 18.6812C23.1336 18.6314 19.1535 22.5307 19.1037 27.3905L20.7036 27.4069C20.7444 23.4307 24.0008 20.2403 27.9771 20.2811L27.9935 18.6812ZM36.7028 27.5709C36.7526 22.7111 32.8533 18.731 27.9935 18.6812L27.9771 20.2811C31.9533 20.3219 35.1436 23.5783 35.1029 27.5545L36.7028 27.5709ZM31.1031 27.5135C31.085 29.2807 29.6377 30.6987 27.8704 30.6806L27.854 32.2805C30.5049 32.3076 32.6758 30.1808 32.703 27.5299L31.1031 27.5135ZM27.936 24.2809C29.7033 24.299 31.1212 25.7463 31.1031 27.5135L32.703 27.5299C32.7302 24.8791 30.6033 22.7082 27.9524 22.681L27.936 24.2809ZM24.7034 27.4479C24.7215 25.6807 26.1688 24.2628 27.936 24.2809L27.9524 22.681C25.3016 22.6538 23.1307 24.7807 23.1035 27.4315L24.7034 27.4479ZM27.8704 30.6806C26.1032 30.6624 24.6853 29.2151 24.7034 27.4479L23.1035 27.4315C23.0763 30.0824 25.2032 32.2533 27.854 32.2805L27.8704 30.6806Z"
        fill="inherit"
        mask="url(#path-8-inside-1_7639_98)"
      />
    </svg>
  );
}
